import React from 'react';
import RouterLink from '../RouterLink';
import LazyPicture from '../LazyPicture';
import { tealiumClickFunc, tealiumMergeClickData } from "../../../utils/tealium";
const CuratorPicks = _ref => {
  let {
    curators,
    copy,
    analytics = {},
    linksTarget
  } = _ref;
  const baseImage = process.env.REACT_APP_MEDIA_HOST || '';
  if (!curators || curators.length === 0) {
    return null;
  }
  const {
    smallBannerClickAnalytics = {},
    params = {},
    name = ''
  } = analytics;
  return /*#__PURE__*/React.createElement("div", {
    className: "curators__block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "curators__row"
  }, curators.map((curator, index) => /*#__PURE__*/React.createElement(RouterLink, {
    key: index,
    linksTarget: linksTarget,
    href: curator.Url,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(smallBannerClickAnalytics, params), name)
  }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: baseImage + curator.Image + '&cw=24&ch=24'
  }), /*#__PURE__*/React.createElement("img", {
    className: "curators__image-item",
    src: baseImage + curator.Image + '&cw=24&ch=24',
    alt: curator.Name
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "curators__author"
  }, copy));
};
export default CuratorPicks;